module.exports = __webpack_public_path__ + "92b5d5f32e894125bb5fe8ba384b5068.svg";